import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
}                         from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RbAuthService }  from '../core';

@Component({
  selector: 'rb-login',
  standalone: false,
  templateUrl: './login.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginComponent implements OnInit {
  authError$ = this.rbAuthService.error$;
  isAuthenticated$ = this.rbAuthService.isAuthenticated$;
  officeId: string | null = null;

  constructor(
    private readonly rbAuthService: RbAuthService,
    private readonly route: ActivatedRoute,
  ) {
  }

  ngOnInit() {
    this.officeId = this.route.snapshot.queryParamMap.get('officeId');
  }

  login() {
    this.rbAuthService.login('/', false);
  }
}
